import { Button } from "components/Buttons";
import TableHeader from "../components/User/TableHeader";
import TableRow from "../components/User/TableRow";
import { Loading } from "../../../components/Loading/Loading";

import { ButtonColorScheme, ButtonType } from "types/ui";
import { Clinician } from "types/Clinician";
import { StatusENUM } from "types/common";

type Props = {
  clinicUserList: Clinician[];
  onClick?: any;
  sortConfig: any;
  loading: boolean;
  onLoadMore: () => void;
  hasMoreItems: boolean;
  editUser: (userId: string) => void;
  disableUser: (userId: string, status?: StatusENUM) => void;
  resendInvitation: (email: string, role: any) => void;
};

const ContainerForClinic = ({
  clinicUserList,
  onClick,
  sortConfig,
  loading,
  onLoadMore,
  hasMoreItems,
  disableUser,
  editUser,
  resendInvitation,
}: Props) => {
  return (
    <>
      <TableHeader onClick={onClick} sortConfig={sortConfig} />
      <div className="w-full min-h-[200px] flex flex-col overflow-y-hidden space-y-[5px] relative">
        {clinicUserList.map((user) => {
          const roles = user.role || [];
          const userRoles = roles.join(",").replace(/,/g, " ");
          console.log({ roles, userRoles, split: roles.join(",") });
          return (
            <TableRow
              authStatus={user.profileInfo.authStatus}
              role={userRoles}
              profileInfo={user.profileInfo}
              key={user._id}
              name={`${user.profileInfo.firstName} ${user.profileInfo.lastName}`}
              clinic={user.clinic}
              disableUser={disableUser}
              resendInvitation={resendInvitation}
              editUser={editUser}
              status={user.status}
              userId={user._id}
            />
          );
        })}
        <Loading loading={loading} states={clinicUserList} />
      </div>

      <Button
        classNames="self-end mt-4"
        title="Load More"
        onClick={onLoadMore}
        type={ButtonType.normal}
        disabled={loading || !hasMoreItems}
        colorScheme={
          hasMoreItems ? ButtonColorScheme.gradient : ButtonColorScheme.disabled
        }
        shadowed={hasMoreItems}
      />
    </>
  );
};

export default ContainerForClinic;
